// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'column-insert';

export const Component = () => (
  <path d='M11.345 17.776s-.526-.176-.526-.527V7.527c0-.351.176-.526.526-.526.32 0 .48.176.48.526v9.722c0 .352-.16.527-.48.527Zm1.485-10.25S12.99 7 13.309 7c.32 0 .479.176.479.527v9.721c0 .352-.16.527-.48.527-.319 0-.478-.176-.478-.527V7.527Zm-8.046 7.472s.143.207.143.335c0 .351-.159.526-.479.526-.032 0-.143-.047-.335-.143l-2.97-2.97a.46.46 0 0 1 0-.67l2.97-2.97c.192-.096.303-.143.335-.143.32 0 .48.175.48.526 0 .128-.048.24-.144.335l-2.107 2.107h5.699c.32 0 .479.16.479.48 0 .319-.16.478-.48.478H2.678l2.107 2.107v.002Zm15.038-5.172a.46.46 0 0 1-.144-.335c0-.352.16-.527.479-.527.064 0 .191.048.383.144l2.92 2.97a.46.46 0 0 1 0 .67l-2.92 2.97a.517.517 0 0 1-.383.143c-.32 0-.479-.16-.479-.479 0-.16.048-.287.144-.383l2.107-2.107h-5.7c-.319 0-.478-.16-.478-.479 0-.32.16-.479.479-.479h5.699l-2.107-2.107v-.001Z' />
);

export const viewBox = '0 0 25 25';
